<template>
  <div id="radar-chart"></div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
export default {
  mounted() {
    this.createChart();
  },
  methods: {
    chart2theme(target) {
      if (target instanceof am4core.ColorSet) {
        target.list = [
          am4core.color("#27c42f"),
          am4core.color("#fcbe03"),
          am4core.color("#fc7b03"),
          am4core.color("#d62020"),
        ];
      }
    },
    createChart() {
     
        am4core.useTheme(this.chart2theme);
        am4core.useTheme(am4themes_animated);


        var chart = am4core.create("radar-chart", am4charts.RadarChart);
    
        chart.data = [
          {
            category: "Baixo",
            value: 10,
            full: 100,
          },
          {
            category: "Médio",
            value: 35,
            full: 100,
          },
          {
            category: "Alto",
            value: 92,
            full: 100,
          },
          {
            category: "Critico",
            value: 68,
            full: 100,
          },
        ];

        chart.startAngle = -90;
        chart.endAngle = 180;
        chart.innerRadius = am4core.percent(20);

        chart.numberFormatter.numberFormat = "#.#'%'";

        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.grid.template.strokeOpacity = 0;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.fontWeight = 500;
        categoryAxis.renderer.labels.template.adapter.add(
          "fill",
          function (fill, target) {
            return target.dataItem.index >= 0
              ? chart.colors.getIndex(target.dataItem.index)
              : fill;
          }
        );
        categoryAxis.renderer.minGridDistance = 10;

        var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.min = 0;
        valueAxis.max = 100;
        valueAxis.strictMinMax = true;

        // Create series
        var series1 = chart.series.push(new am4charts.RadarColumnSeries());
        series1.dataFields.valueX = "full";
        series1.dataFields.categoryY = "category";
        series1.clustered = false;
        series1.columns.template.fill = new am4core.InterfaceColorSet().getFor(
          "alternativeBackground"
        );
        series1.columns.template.fillOpacity = 0.08;
        series1.columns.template.cornerRadiusTopLeft = 20;
        series1.columns.template.strokeWidth = 0;
        series1.columns.template.radarColumn.cornerRadius = 20;

        var series2 = chart.series.push(new am4charts.RadarColumnSeries());
        series2.dataFields.valueX = "value";
        series2.dataFields.categoryY = "category";
        series2.clustered = false;
        series2.columns.template.strokeWidth = 0;
        series2.columns.template.tooltipText = "{category}: [bold]{value}[/]";
        series2.columns.template.radarColumn.cornerRadius = 20;

        series2.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Add cursor
        chart.cursor = new am4charts.RadarCursor();

    },
  },
};
</script>
<style lang="scss">
#radar-chart {
  height: 400px;
}
</style>